import React, { Fragment } from 'react';
import ReactSVG from 'react-svg';
import styled from 'styled-components';

import { COLORS } from 'config/theme';

import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import SessionsSrc from 'images/users/sessions.svg';
import PageviewsSrc from 'images/users/pageviews.svg';
import ClicksSrc from 'images/users/clicks.svg';
import FormInteractionsSrc from 'images/users/form_interactions.svg';

import { EVENTS } from '../../Users.config';

const StyledViewTabs = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

const styles = {
  tabsRoot: {
    height: '100%',
    minHeight: 'auto',
  },
  tabRoot: {
    minWidth: 'none',
    height: 49,
    margin: '0',
    position: 'relative',
    zIndex: 1,
    opacity: 1,
    fontWeight: 400,
    color: COLORS.primaryColor,
    '& svg': {
      color: 'rgba(31, 38, 107, 0.64)',
    },
    '&:hover': {
      background: 'rgba(31, 38, 107, 0.06)',
    },
  },
  indicator: {
    bottom: 0,
  },
  label: {
    height: '100%',
    fontSize: 14,
    letterSpacing: 1.3,
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.33s',
    transitionDelay: '0.1s',

    '& svg': {
      maxWidth: 20,
      maxHeight: 'auto',
      marginRight: 9,
    },
  },
  labelContainer: {
    height: 33,
    paddingTop: 0,
    paddingBottom: 0,
  },
  selected: {
    color: COLORS.primaryColor,
    '& svg': {
      color: COLORS.primaryColor,
    },
  },
};


const ViewTabs = ({ classes, selectedEvent, handleViewChange }) => {
  const tabClasses = {
    root: classes.tabRoot,
    label: classes.label,
    selected: classes.selected,
    labelContainer: classes.labelContainer,
  };

  const onChange = (event, value) => {
    handleViewChange(value);
  };

  return (
    <StyledViewTabs>
      <Tabs
        value={selectedEvent}
        indicatorColor="primary"
        classes={{ root: classes.tabsRoot, indicator: classes.indicator }}
        onChange={onChange}
      >
        <Tab
          classes={tabClasses}
          label={<Fragment><ReactSVG path={SessionsSrc} />{EVENTS.sessions.name}</Fragment>}
          value={EVENTS.sessions.id}
        />
        <Tab
          classes={tabClasses}
          label={<Fragment><ReactSVG path={PageviewsSrc} />{EVENTS.pageviews.name}</Fragment>}
          value={EVENTS.pageviews.id}
        />
        <Tab
          classes={tabClasses}
          label={<Fragment><ReactSVG path={ClicksSrc} />{EVENTS.clicks.name}</Fragment>}
          value={EVENTS.clicks.id}
        />
        <Tab
          classes={tabClasses}
          label={<Fragment><ReactSVG path={FormInteractionsSrc} />{EVENTS.form_interactions.name}</Fragment>}
          value={EVENTS.form_interactions.id}
        />
      </Tabs>
    </StyledViewTabs>
  );
};

export default withStyles(styles)(ViewTabs);



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/Details/ViewTabs/ViewTabs.jsx